import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import api from "api";
import { querykeys } from "api/querykeys";

import { Alert, AuthLayout, Flex, Loader } from ".";

export const CheckServiceAvailability: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { t } = useTranslation();
  const { data, isLoading, isFetching } = useQuery(querykeys.serviceAvailability, () => api.checkServiceAvailability());

  if (isFetching || !data?.service_available) {
    return (
      <AuthLayout>
        {isLoading && <Loader size="lg" spread />}
        {!data?.service_available && !isLoading && (
          <Flex justify="center" align="center" style={{ width: "100vw", height: "100vh" }}>
            <Alert variant="danger" title={t("access_denied")} />
          </Flex>
        )}
      </AuthLayout>
    );
  }

  return <>{children}</>;
};
